import React from "react";
import {
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTagList,
  TimelineTagPill,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const AssigneesUpdated = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">assigned by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    {milestone.details[0].newAssignees && milestone.details[0].newAssignees.length > 0 &&
      <TimelineSection>
        <TimelineSectionTitle>Added</TimelineSectionTitle>
        <TimelineTagList>
          {milestone.details[0].newAssignees.map((assignee) => (
            <TimelineTagPill key={assignee}>{assignee}</TimelineTagPill>
          ))}
        </TimelineTagList>
      </TimelineSection>
    }
    {milestone.details[0].removedAssignees && milestone.details[0].removedAssignees.length > 0 &&
      <TimelineSection>
        <TimelineSectionTitle>Removed</TimelineSectionTitle>
        <TimelineTagList>
          {milestone.details[0].removedAssignees.map((assignee) => (
            <TimelineTagPill key={assignee}>{assignee}</TimelineTagPill>
          ))}
        </TimelineTagList>
      </TimelineSection>
    }
  </TimelineContent>
)

export default AssigneesUpdated
